module.exports = __webpack_public_path__ + "static/media/banner2.66ed2b5f.jpg";